export const MIN_NUMBER_OF_GROUPS = 2;

export const ERROR_MSG = {
    ALLOC_GROUPS: `To compute a new group, the number of groups must be at least ${MIN_NUMBER_OF_GROUPS}`,
    NO_USER: 'Experiment Type "user" can only be used when logged in - no userId supplied.',
    NO_GUEST_ID: 'Must supply guest id when calculating for "guest" experiments'
};
